import { call } from 'redux-saga/effects';

import {imgPath} from '~common/utilities/ImgUrl';
import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PredictiveModelCard } from '~src/predictiveModel/components/cardView/PredictiveModelCard';
import { PredictiveModels } from '~src/predictiveModel/resources/PredictiveModels';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { PredictiveModelContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getPredictiveModelInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getGenericDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

export const PredictiveModelDefinition: MixedContentItemDefinition & SpaceDefinition<'predictiveModel'> = {
  itemType: 'predictiveModel',
  contentType: 'predictiveModel',
  singularName: Messages.predictiveModel,
  pluralName: Messages.predictiveModels,
  emptyStateMessage: Messages.predictiveModelsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PredictiveModels,
  contentFilterKeys: PredictiveModelContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: PredictiveModelCard,
  listViewIconUrl: imgPath('einstein_icon_18x18.svg'),
  filterClause: ServerFilterClauses.ContentType(['predictiveModel']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.predictiveModelUrl(contentId),
  getBasicQuery: () => {
    return PredictiveModels.all().withExtraParams(PredictiveModelContentType.extraQueryParams);
  },
  fieldValueResourceType: 'predictiveModel',
  getContentInfo: (contentList: IContentInfo[]) => call(getPredictiveModelInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: (contentInfo) => '',
};
